var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-copyright-note",style:(_vm.frameStyle)},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('img',{attrs:{"src":_vm.logo,"width":"20","height":"20"}})])}
var staticRenderFns = []

export { render, staticRenderFns }